const variants = {
  primary: 'badge-primary',
  success: 'badge-success',
  warning: 'badge-warning',
  danger: 'badge-danger',
  gray: 'badge-gray',
  blue: 'bg-blue-300/14 text-blue-100',
};

export default function Badge({ children, variant = 'gray', className = '' }) {
  return (
    <span className={`
      badge
      ${variants[variant]}
      ${className}
    `}>
      {children}
    </span>
  );
}
